import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Text } from "@nxt-costco-com/forge-components";
import { AccountAlt } from "@nxt-costco-com/forge-icons/icons/AccountAlt";
import { AccountDrawer } from "../../../Account/AccountMenus/AccountDrawer/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { iconStyles, textStyles } from "./styles.js";
function AccountView({ dataTestId, entry }) {
  if (!entry) return null;
  const uniqueId = `${dataTestId}-account`;
  return /* @__PURE__ */ jsx(AccountDrawer, { locale: entry.locale, children: /* @__PURE__ */ jsxs(
    Button,
    {
      sx: {
        alignItems: "center",
        display: "flex",
        flexDirection: { lg: "row", xs: "column" },
        width: "fit-content"
      },
      "data-testid": uniqueId,
      variant: "text-button",
      children: [
        /* @__PURE__ */ jsx(CostcoBox, { component: AccountAlt, sx: iconStyles }),
        /* @__PURE__ */ jsx(Text, { sx: textStyles, uniqueId, children: entry.active_state.active_state_link.title })
      ]
    }
  ) });
}
export {
  AccountView
};
